/**
 * 任务组相关(包括任务)
 */

import BaseAuthClient from './baseAuth';

class TaskGroupClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const taskGroupClient = new TaskGroupClient();

export default taskGroupClient;

// 新建任务
export const createTask = (option: any) => taskGroupClient.post(`/v1/project/addtask`, option);

// 编辑任务
export const editTask = (option: any) => taskGroupClient.post(`/v1/task/edittask`, option);

// 获取任务组下的任务
export const getTaskList = (option: any) => taskGroupClient.get(`/v1/project/gettasks`, option);

// 获取任务详情所有环节
export const getTaskDetail = (option: any) => taskGroupClient.get(`/v1/project/getonetask`, option);

// 新建任务组
export const createTaskGroup = (option: any) => taskGroupClient.post(`/v1/project/addtaskgroup`, option);

// 删除/恢复任务组
export const setStatusTaskGroup = (option: any) => taskGroupClient.post(`/v1/project/setstatustaskgroup`, option);

// 删除/恢复任务
export const setStatusTask = (option: any) => taskGroupClient.post(`/v1/project/setstatustask`, option);

// 编辑任务组
export const eidtTaskGroup = (option: any) => taskGroupClient.put(`/v1/project/edittaskgroup`, option);

// 添加任务获取任务默认环节
export const getLinks = (option: any) => taskGroupClient.get(`/v1/task/getlinks`, option);

// 添加任务添加环节
export const addTemplate = (option: any) => taskGroupClient.post(`/v1/project/addtemplate`, option);

// 获取任务组
export const getTaskGroupList = (option: any) => taskGroupClient.get(`/v1/project/gettaskgroup`, option);

// 获取任务组和状态
export const getTaskGroupStatus = (option: any) => taskGroupClient.get(`/v1/project/gettaskgroupstatus`, option);

// 获取任务和状态
export const getTaskStatus = (option: any) => taskGroupClient.get(`/v1/project/gettaskstatus`, option);

// 修改件数
export const editLinkInfo = (option: any) => taskGroupClient.put(`/v1/link/editlinkinfo`, option);

// 重置环节
export const resetLink = (option: any) => taskGroupClient.put(`/v1/link/resetlink`, option);

// 多审批列表
export const getlistByLinkid = (option: any) => taskGroupClient.get(`/v1/processinstances/getlistbylinkid`, option);

// 审批详情
export const getDetailByid = (option: any) => taskGroupClient.get(`/v1/processinstances/getdetailbyid`, option);

// 提交画稿
export const submitFile = (option: any) => taskGroupClient.post(`/v1/link/submitfile`, option);

// 任务组回收站
export const recycleBin = (option: any) => taskGroupClient.get(`/v1/taskgroup/recyclebin`, option);

// 任务回收站
export const recycleBinTask = (option: any) => taskGroupClient.get(`/v1/task/recyclebin`, option);

// 验证任务组是否恢复
export const getTaskCycleStatus = (option: any) => taskGroupClient.get(`/v1/taskgroup/gettaskrecyclestatus`, option);

// 修改逾期状态
export const setStoverDuestatus = (option: any) => taskGroupClient.post(`/v1/link/setoverduestatus`, option);

// 修改任务组排序
export const setGroupOrder = (option: any) => taskGroupClient.post(`/v1/taskgroup/setorder`, option);

// 修改任务排序
export const setTaskOrder = (option: any) => taskGroupClient.post(`/v1/task/setorder`, option);

// 设置环节状态
export const setLinkStatus = (option: any) => taskGroupClient.post(`/v1/link/setlinkstatus`, option);

// 修改环节单价
export const editLinkPrice = (option: any) => taskGroupClient.put(`/v1/link/editlinkprice`, option);

